import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { NAV_ITEMS } from "@/data/navigation";
import { SITE } from "@/data/site";
import { FOOTER_EXPERTISES } from "./footer-data";

const ColumnHeading = ({ children }: { children: string }) => (
  <p className="text-xs uppercase tracking-[0.2em] text-white/70">{children}</p>
);

export const FooterColumns = () => (
  <div className="grid gap-10 sm:grid-cols-3 lg:col-span-7">
    <div>
      <ColumnHeading>Navigation</ColumnHeading>
      <ul className="mt-5 space-y-3 text-sm">
        {NAV_ITEMS.map((item) => (
          <li key={item.to}>
            <Link to={item.to} className="text-white/80 transition-colors hover:text-white">
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
    <div>
      <ColumnHeading>Expertises</ColumnHeading>
      <ul className="mt-5 space-y-3 text-sm text-white/80">
        {FOOTER_EXPERTISES.map((e) => (
          <li key={e}>{e}</li>
        ))}
      </ul>
    </div>
    <div>
      <ColumnHeading>Contact</ColumnHeading>
      <ul className="mt-5 space-y-3 text-sm text-white/80">
        <li className="flex gap-3">
          <MapPin className="mt-0.5 size-4 shrink-0 text-white/70" aria-hidden />
          {SITE.city}
        </li>
        <li className="flex gap-3">
          <Phone className="mt-0.5 size-4 shrink-0 text-white/70" aria-hidden />
          <a href={`tel:${SITE.phoneE164}`} className="transition-colors hover:text-white">
            {SITE.phoneDisplay}
          </a>
        </li>
        <li className="flex gap-3">
          <Mail className="mt-0.5 size-4 shrink-0 text-white/70" aria-hidden />
          <a href={`mailto:${SITE.email}`} className="break-all transition-colors hover:text-white">
            {SITE.email}
          </a>
        </li>
      </ul>
    </div>
  </div>
);
